import React from 'react';
import { connect } from 'react-redux';

const FormSelect = ({ name = '', value = '', onValueChange, options, disabled = false, role, element = undefined, assign = false }) => {
    return (
        <div className="flex-v mt-16">
            {name !== '' &&
                <div>
                    <h4>{name} :</h4>
                </div>
            }
            <div>
                <select disabled={disabled} value={value} onChange={e => onValueChange(e.target.value, element)}>
                    {options.map((option, i) => {
                        return <option key={i} value={assign ? i : option}>{option}</option>
                    })}
                </select>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        role: state.auth.role
    }
}

export default connect(mapStateToProps)(FormSelect);